//dependencias
import React, { Component } from 'react';

//componentes
import Comprobante from './comprobante';
class Index extends Component {
    render() {
        return(
            <div className="Inicio">
                <Comprobante /> 
            </div>
        );
    }
}
export default Index;